import { clickOutside } from '@portal/utils/util-click-outside';
import {
  disableBodyScroll,
  clearAllBodyScrollLocks,
  enableBodyScroll
} from 'body-scroll-lock';
import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';

import styles from './jtn-ui-mobile-context-menu.styles.scss?module';

interface Events {
  onClick: Event;
  onCloseClicked: void;
}

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'JtnUiMobileContextMenu',
    props: {
      isShowCloseButton: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      closeMenu(): void {
        enableBodyScroll(this.$el);

        this.$emit('closeClicked');
      }
    },
    mounted() {
      disableBodyScroll(this.$el);

      if (this.$refs.contextMenuWrap !== null) {
        clickOutside(this.$refs.contextMenuWrap as HTMLElement, () => this.closeMenu(), {
          isSkipFirstClick: false
        });
      }
    },
    beforeDestroy() {
      clearAllBodyScrollLocks();
    },
    render() {
      const attributes = {
        attrs: this.$attrs,
        on: this.$listeners
      };

      return (
        <div
          class={[
            styles.jtnUiMobileContextMenu,
            'mobileContextMenu',
            this.isShowCloseButton ? styles.withCloseButton : ''
          ]}
          {...attributes}
        >
          <div class={styles.inner}>
            <div ref="contextMenuWrap" class={styles.controls}>
              {this.$slots.default}
            </div>

            {this.isShowCloseButton && (
              <svg
                class={styles.closeButton}
                width={16}
                height={16}
                nativeOnClick={() => this.closeMenu()}
              >
                <use xlinkHref="/dist/legacy/svg-sprites/jtn-critical.42b7545660e4f467e75d4b37a02533e6.svg#jtn-critical-close" />
              </svg>
            )}
          </div>
        </div>
      );
    }
  });
